import { createReducer } from 'redux-starter-kit';
import {
  setMissingDataStatus,
  setMissingDataUpdating,
  clearMissingDataStatus,
} from '../actions/missing-data';

/**
 * State shape:
 * {
 *   [projectId]: {
 *     status: 'idle' | 'scheduled' | 'in_progress' | 'completed',
 *     scheduledAt: string | null,
 *     lastCalculation: string | null,
 *     updating: boolean,
 *   }
 * }
 */
export const missingDataInitialState = {};

const setStatusClbk = (state, action) => {
  const { projectId, ...rest } = action.payload;
  return {
    ...state,
    [projectId]: {
      ...state[projectId],
      ...rest,
    },
  };
};

const setUpdatingClbk = (state, action) => {
  const { projectId, updating } = action.payload;
  return {
    ...state,
    [projectId]: {
      ...state[projectId],
      updating,
    },
  };
};

const clearStatusClbk = (state, action) => {
  const { projectId } = action.payload;
  const newState = { ...state };
  delete newState[projectId];
  return newState;
};

const missingDataReducer = createReducer(missingDataInitialState, {
  [setMissingDataStatus]: setStatusClbk,
  [setMissingDataUpdating]: setUpdatingClbk,
  [clearMissingDataStatus]: clearStatusClbk,
});

export default missingDataReducer;
